import { createContext, useContext } from 'react';

// 1. Initialize the Context
const AppContext = createContext(null);

// 2. Export the Hook
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};

// 3. Export the Context Object (for the Provider)
export default AppContext;